import { networkCaches } from "@/cache/GlobalCache";
import type { RetryState } from "@/cache/SpatioTemporalTileCache/RetryState";
import type { CustomGeoJsonRequestOption } from "@/layers/geojson/custom";
import { addValueToFeature } from "@/threads/DataProcessingThread/utils/custom-geojson";
import { enumValues, toEnumValue } from "@/utility/enum";
import { Aggregate, type CoordinateSystem, type PolygonRequest } from "@mm/api.meteomatics.com";
import type { Feature, GeoJsonProperties, Geometry, Polygon } from "geojson";
import { type DateTime, Duration } from "luxon";
export function hydratePolygonFeatures(
  features: Array<Feature<Polygon, GeoJsonProperties>>,
  parameter: string,
  model: string,
  datetime: DateTime,
  customGeoJsonRequestOption: CustomGeoJsonRequestOption,
  retry: RetryState,
): Promise<Feature<Geometry, GeoJsonProperties>[]>[] {
  return features.flatMap((feature) => {
    const request: PolygonRequest<CoordinateSystem.WGS84> = {
      feature,
      // Right now hardcode to Max, but later we should have dropdown, that allows user to select aggregation
      aggregate: toEnumValue<Aggregate>(
        customGeoJsonRequestOption.customOption.aggregate_value || "",
        enumValues(Aggregate),
        Aggregate.max,
      ),
      startDatetime: datetime,
      duration: Duration.fromISO("PT1H"),
      temporalResolution: Duration.fromISO("PT1H"),
      width: 0,
      height: 0,
      parameters: [parameter],
      model,
      boundingBoxLimit: null,
    };
    return networkCaches.polygonJson_cache.retrievePolygon(request).asynchronous.then((data) => {
      // This looks very ugly, but we don't have nice way to traverse API data
      const value = data[0][0].dates[0]?.value;

      if (value != null) {
        return [addValueToFeature(feature, value)];
      }

      return [feature];
    });
  });
}
